export default __webpack_public_path__ + "static/media/hht2_ep08_book_wp_02.f87be7ff.jpg";